import { ROLES } from 'src/constants/auth';

import Permissions from './permissions';

const PromoterPermissions: Permissions[] = [
  Permissions.LIST_VEHICLES,
  Permissions.LIST_ALLIANCES,
  Permissions.LIST_EXPIRED,
  Permissions.SHOW_VEHICLES,
  Permissions.ACCOUNT_VEHICLES,
  Permissions.REFRESH_VEHICLES,
  Permissions.RETRIVE_FACEBOOK_PAGES,
  Permissions.SHARE_VEHICLES,
];

const SellerPermissions: Permissions[] = [
  Permissions.SELF_ALLIANCES,
  Permissions.LIST_VEHICLES,
  Permissions.LIST_ALLIANCES,
  Permissions.LIST_EXPIRED,
  Permissions.STORE_VEHICLES,
  Permissions.UPDATE_VEHICLES,
  Permissions.SHOW_VEHICLES,
  Permissions.EXPIRE_VEHICLES,
  Permissions.ACCOUNT_VEHICLES,
  Permissions.REFRESH_VEHICLES,
  Permissions.ADD_VEHICLES_IMAGES,
  Permissions.DELETE_VEHICLES_MEDIA,
  Permissions.RETRIVE_FACEBOOK_PAGES,
  Permissions.SHARE_VEHICLES,
  Permissions.GET_SHARE_URL
];

const ManagerPermissions: Permissions[] = [
  Permissions.SELF_ALLIANCES,
  Permissions.LIST_VEHICLES,
  Permissions.LIST_ALLIANCES,
  Permissions.LIST_EXPIRED,
  Permissions.STORE_VEHICLES,
  Permissions.UPDATE_VEHICLES,
  Permissions.DELETE_VEHICLES,
  Permissions.SHOW_VEHICLES,
  Permissions.EXPIRE_VEHICLES,
  Permissions.ACCOUNT_VEHICLES,
  Permissions.REFRESH_VEHICLES,
  Permissions.ADD_VEHICLES_IMAGES,
  Permissions.DELETE_VEHICLES_MEDIA,
  Permissions.LIST_APP_USERS,
  Permissions.CREATE_APP_USERS,
  Permissions.SHOW_APP_USER,
  Permissions.UPDATE_APP_USER,
  Permissions.DELETE_APP_USER,
  Permissions.RETRIVE_FACEBOOK_PAGES,
  Permissions.SHARE_VEHICLES,
  Permissions.GET_SHARE_URL
];

const AppAdminPermissions: Permissions[] = [
  // TODO: Replace with full permissions list
  ...ManagerPermissions,
  Permissions.ACCESS_SCREEN_ACCOUNT
];

const SuperAdminPermissions: Permissions[] = [
  // TODO: Replace with full permissions list
  ...AppAdminPermissions,
  Permissions.ACCESS_SCREEN_API_KEYS
];

const StaffPermissions: Permissions[] = [
  // TODO: Replace with real permissions
  ...AppAdminPermissions,
];

const AdminPermissions: Permissions[] = [
  // TODO: Replace with real permissions
  ...StaffPermissions,
];

const PERMISSIONS_BY_ROLE = {
  [ROLES.PROMOTER]: PromoterPermissions,
  [ROLES.SELLER]: SellerPermissions,
  [ROLES.MANAGER]: ManagerPermissions,
  [ROLES.APPADMIN]: AppAdminPermissions,
  [ROLES.SUPER_ADMIN]: SuperAdminPermissions,
  [ROLES.STAFF]: StaffPermissions,
  [ROLES.ADMIN]: AdminPermissions,
};

export default PERMISSIONS_BY_ROLE;
